import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { TyreDiscountsDashboardQueryKeys } from "modules/TyreDiscountsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { TyreBrandDiscount } from "models";

export const useUpdateTyreBrandDiscountMutation = () =>
  useTypedMutation<TyreBrandDiscount, void>({
    mutationFn: async (payload: TyreBrandDiscount) => (await ApiInstance.post("/tyre_discounts/update_brand", payload, ENV.dealerBaseURL)).data,
    onSuccess: payload => {
      const discounts = typedQueryClient.getQueryData(TyreDiscountsDashboardQueryKeys.discounts);
      if (!discounts) return;

      const discountIdx = discounts.findIndex(discount => discount.id === payload.tyre_discount_id);
      if (discountIdx === -1) return;

      const tyreBrandDiscounts = discounts[discountIdx].tyre_brand_discounts;
      if (!tyreBrandDiscounts) return;

      const tyreBrandDiscountIdx = tyreBrandDiscounts.findIndex(bd => bd.id === payload.id);
      if (tyreBrandDiscountIdx === -1) return;

      typedQueryClient.setQueryData(
        TyreDiscountsDashboardQueryKeys.discounts,
        discounts.with(discountIdx, {
          ...discounts[discountIdx],
          tyre_brand_discounts: tyreBrandDiscounts.with(tyreBrandDiscountIdx, { ...tyreBrandDiscounts[tyreBrandDiscountIdx], ...payload })
        })
      );
    }
  });
